import { EnvelopeIcon } from '@heroicons/react/24/outline';
import React from 'react';

import {
  EMAIL_FALLBACK,
  LINK_ON_ITS_WAY,
  LINK_SENT_EYEBROW,
  LINK_SENT_LEDE,
  verificationLinkReceipt,
} from '@personal-trainer-app/shared';

import { AuthMessage } from '../AuthMessage';
import { EmailAddress } from '../EmailAddress';
import { LinkReceipt } from '../LinkReceipt';
import { ResendLinkButton } from '../ResendLinkButton';
import { SendLinkFailureAlert } from '../SendLinkFailureAlert';

import type { VerificationLinkSentProps } from './VerificationLinkSent.types';

/**
 * A new verification link is on its way: where it went, how long it works,
 * and a resend that waits out its pause. The `/verify-email` page and the
 * unverified gate both show it, each adding its own way on.
 */
export function VerificationLinkSent({
  email,
  sentAt,
  remaining,
  sending,
  failure,
  notice,
  onResend,
  headingRef,
  children,
}: VerificationLinkSentProps): React.JSX.Element {
  return (
    <AuthMessage
      icon={<EnvelopeIcon />}
      tone="accent"
      eyebrow={LINK_SENT_EYEBROW}
      title={LINK_ON_ITS_WAY}
      lede={
        <>
          {LINK_SENT_LEDE.before}
          <EmailAddress email={email} fallback={EMAIL_FALLBACK} />
          {LINK_SENT_LEDE.after}
        </>
      }
      headingRef={headingRef}
    >
      <LinkReceipt className="mb-6" rows={verificationLinkReceipt(sentAt)} />
      {failure ? (
        <SendLinkFailureAlert failure={failure} className="mb-6" />
      ) : null}
      {notice}
      <ResendLinkButton
        remaining={remaining}
        loading={sending}
        onClick={onResend}
      />
      {children}
    </AuthMessage>
  );
}

export default VerificationLinkSent;
